import { render } from "./ChooseLocalAverageType.vue?vue&type=template&id=3ed5d9de&scoped=true"
import script from "./ChooseLocalAverageType.vue?vue&type=script&lang=js"
export * from "./ChooseLocalAverageType.vue?vue&type=script&lang=js"

import "./ChooseLocalAverageType.vue?vue&type=style&index=0&id=3ed5d9de&scoped=true&lang=css"
import "./ChooseLocalAverageType.vue?vue&type=style&index=1&id=3ed5d9de&scoped=true&lang=css"

import exportComponent from "/home/forge/staging.hikeseo.co/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ed5d9de"]])

export default __exports__